import React from 'react';
import '../styles/footer.css';

const Footer = (props) => {

    const refreshData = () => {
        props.refreshData();
    }

    return(
        <>
            <div className="mainContainerFooter">
                <div className="colFooter_1">
                    <img className="logoFooter" alt="logo" src="https://ftpeople.pl/wp-content/uploads/2023/06/logomain.png"/>
                </div>
                <div className="colFooter_2">
                    <button className="refreshButton" onClick={refreshData}>Odśwież</button>
                    © FTP 2022
                </div>
            </div>
        </>
    );
}

export default Footer;